var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavigationAlarmBlack24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12.982V9.25803C18.5258 7.53961 17.8868 5.87765 16.7164 4.61914C15.546 3.36063 13.9347 2.60285 12.219 2.50403C11.351 2.47738 10.4865 2.62533 9.67681 2.93909C8.8671 3.25285 8.12865 3.72604 7.50527 4.33058C6.88188 4.93513 6.38627 5.65871 6.04781 6.45842C5.70936 7.25812 5.53496 8.11765 5.53497 8.98603V12.986L3.65297 16.701C3.54507 16.9143 3.49357 17.1516 3.50338 17.3905C3.51318 17.6293 3.58396 17.8616 3.70897 18.0653C3.83398 18.269 4.00907 18.4373 4.21755 18.5542C4.42603 18.6711 4.66096 18.7327 4.89997 18.733H19.137C19.3761 18.733 19.6113 18.6717 19.8201 18.5549C20.0288 18.4382 20.2042 18.2699 20.3294 18.0661C20.4547 17.8624 20.5256 17.6299 20.5355 17.391C20.5454 17.152 20.4939 16.9145 20.386 16.701L18.5 12.982Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.569 18.537C15.5541 19.3871 15.2059 20.1973 14.5994 20.7932C13.9929 21.3891 13.1767 21.723 12.3265 21.723C11.4762 21.723 10.66 21.3891 10.0536 20.7932C9.4471 20.1973 9.09891 19.3871 9.08398 18.537",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigationAlarmBlack24);
export default __webpack_public_path__ + "static/media/icon_navigation_alarm_black_24.344c03c4fe7dd254e11d71c7151812da.svg";
export { ForwardRef as ReactComponent };